/*
  COREEX FAQ — category tab switching.

  ONLY the tabs need script. The accordion rows are Focal's own
  <collapsible-content> and is="toggle-button", which already handle
  open/close, the animation and the editor's block-select event.

  Progressive enhancement: the markup ships with every panel after the first
  carrying [hidden], and this file does nothing until it runs. If it never runs
  the CSS leaves all panels visible, so no question is trapped behind a control
  that cannot be operated. That is why the panels are not hidden from CSS.

  Keyboard behaviour follows the WAI-ARIA tabs pattern: arrows move between
  tabs, Home and End jump to the ends, and only the selected tab is in the tab
  order so a keyboard user tabs past the whole rail in one press.
*/
(function () {
  'use strict';

  function initFaq(root) {
    if (root.dataset.coreexReady === 'true') return;
    root.dataset.coreexReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (tabs.length < 2) return;

    function panelFor(tab) {
      var id = tab.getAttribute('aria-controls');
      return id ? root.querySelector('#' + CSS.escape(id)) : null;
    }

    function select(tab, focusIt) {
      tabs.forEach(function (other) {
        var isTarget = other === tab;
        other.setAttribute('aria-selected', isTarget ? 'true' : 'false');
        other.tabIndex = isTarget ? 0 : -1;

        var panel = panelFor(other);
        if (!panel) return;
        if (isTarget) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });

      if (focusIt) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        select(tab, false);
      });

      tab.addEventListener('keydown', function (event) {
        var next = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = tabs[(index + 1) % tabs.length];
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = tabs[(index - 1 + tabs.length) % tabs.length];
            break;
          case 'Home':
            next = tabs[0];
            break;
          case 'End':
            next = tabs[tabs.length - 1];
            break;
          default:
            return;
        }

        event.preventDefault();
        select(next, true);
      });
    });

    /*
      Theme editor: selecting a Question block should reveal the category it
      lives in, otherwise the merchant clicks a block in the sidebar and the
      preview appears not to respond.
    */
    root.addEventListener('shopify:block:select', function (event) {
      var panel = event.target.closest('.coreex-faq__panel');
      if (!panel) return;

      var owner = tabs.filter(function (tab) {
        return tab.getAttribute('aria-controls') === panel.id;
      })[0];

      if (owner) select(owner, false);
    });
  }

  function initAll(scope) {
    var target = scope || document;
    Array.prototype.forEach.call(target.querySelectorAll('[data-coreex-faq]'), initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* A re-rendered section arrives as fresh DOM with no listeners; the dataset
     guard above stops untouched ones initialising twice. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
